import reconcilePersistedState from '../../helpers/reconcilePersistedState';

const defaultState = {
  displayedTicketIds: [],
  displayedProductIds: [],
  displayedBundleIds: [],
};
const initialState = defaultState;

export function continueShoppingModal(state = initialState, action) {
  switch (action.type) {
    case 'CONTINUE_SHOPPING_MODAL_SET_TICKET_IDS':
      return { ...state, displayedTicketIds: Array.isArray(action.val) ? [...action.val] : state.displayedTicketIds };
    case 'CONTINUE_SHOPPING_MODAL_SET_PRODUCT_IDS':
      return { ...state, displayedProductIds: Array.isArray(action.val) ? [...action.val] : state.displayedProductIds };
    case 'CONTINUE_SHOPPING_MODAL_SET_BUNDLE_IDS':
      return { ...state, displayedBundleIds: Array.isArray(action.val) ? [...action.val] : state.displayedBundleIds };
    case 'RECONCILE_PERSISTED_STATE':
      return reconcilePersistedState(state, defaultState);
    default:
      return state;
  }
}
